import { Dialog } from 'quasar';
import { useLoadingStore } from '~/stores/loading';
import { getGameName } from '@/common/js/gameAbout';

export default defineNuxtPlugin((nuxtApp) => {
    const loadingStore = useLoadingStore();
    let timer: any = null;
    let errDialog: any = null;

    if (!process.dev) {
        // 全局 Vue 错误捕获
        nuxtApp.vueApp.config.errorHandler = (err: any, instance, info) => {
            console.error('[全局捕獲錯誤]', err?.message || err, info);

            const msg = String(err?.message || err || '');
            const isNetworkError = /ERR_INTERNET_DISCONNECTED|ERR_NETWORK|ERR_CONNECTION|Failed to fetch|Load failed|preload CSS|preload JS|NetworkError/i.test(msg);
            if (isNetworkError) {
                console.warn('[全局捕獲錯誤] 网络类错误已忽略:', msg);
                return;
            }

            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            if (errDialog) errDialog.hide();

            timer = setTimeout(() => {
                if (loadingStore.gameLoading || loadingStore.showLoading) {
                    errDialog = Dialog.create({
                        message: `${getGameName()} 错误信息：${err?.message || err}`,
                        html: true,
                        persistent: true,
                    });
                }
            }, 5 * 1000);
        };
    }
});
